(function () {
    'use strict';

    var LARGE = "large",
        NARROW = "narrow",
        MEDIUM = "medium";

    var
        _renderFiltersExpanded = false;

    function TeaserGridLayouter() {
        var
            _layoutMap = [
                LARGE,
                NARROW,
                NARROW,
                MEDIUM,
                LARGE,
                MEDIUM,

                MEDIUM,
                LARGE,
                MEDIUM,
                LARGE,
                NARROW,
                NARROW
            ];

        function getLayout(index) {
            return _layoutMap[index % _layoutMap.length];
        }

        function getTakeCount(alreadyTaken) {
            return 6;
        }

        function testForNewColumn(index) {
            return index % 3 === 0;
        }

        function adjustColumns(columns) {
            var
                tmpColumn, tmpTeaser;

            // check if we have an uneven number of columns
            if (columns.length % 2 !== 0) {
                // create an extra column and put one more entry into the second column than in the first one
                if (columns[columns.length - 1].length === 1) {
                    tmpColumn = [];
                } else {
                    tmpColumn = columns[columns.length - 1].splice(Math.floor(columns[columns.length - 1].length / 2));
                }

                // set the layout of all the entries in the first column to the MEDIUM layout except for the first one that will be set to LARGE
                columns[columns.length - 1].forEach(function (teaser, index) {
                    if (index === 0) {
                        teaser.layout = LARGE;
                    } else {
                        teaser.layout = MEDIUM;
                    }
                });
                // All layouts in the extra column will be set to MEDIUM
                tmpColumn.forEach(function (teaser) {
                    teaser.layout = MEDIUM;
                });
                columns.push(tmpColumn);
            }

            // check if there is only one element in the right hand column (and more than two in the left column). If so, move one from the left column
            if (columns[columns.length - 1].length === 1 && columns[columns.length - 2].length > 2) {
                tmpTeaser = columns[columns.length - 2].pop();
                columns[columns.length - 1].push(tmpTeaser);

                // now modify the layouts of the last two columns
                columns[columns.length - 2].forEach(function (teaser, index) {
                    if (index === 0) {
                        teaser.layout = LARGE;
                    } else {
                        teaser.layout = MEDIUM;
                    }
                });
                columns[columns.length - 1].forEach(function (teaser, index) {
                    if (index < 2) {
                        teaser.layout = NARROW;
                    } else {
                        teaser.layout = MEDIUM;
                    }
                });
            }
        }

        return {
            getLayout: getLayout,
            getTakeCount: getTakeCount,
            testForNewColumn: testForNewColumn,
            adjustColumns: adjustColumns
        };
    }

    function ProjectsGridLayouter() {
        function getLayout(index) {
            if (index === 0) {
                return LARGE;
            }
            return NARROW;
        }

        function getTakeCount(alreadyTaken) {
            if (alreadyTaken === 0) {
                return 7;
            }
            return 8;
        }

        function testForNewColumn(index) {
            if (index === 0 || index === 3) {
                return true;
            }
            return (index + 1) % 4 === 0;
        }

        function adjustColumns(columns) {
            var tmpColumn, col1, col2, tmp;
            var diff, d;

            // check if we have an uneven number of columns
            if (columns.length % 2 !== 0) {
                // create an extra column and put one more entry into the second column than in the first one
                tmpColumn = [];
                columns.push(tmpColumn);
            }

            col1 = columns[columns.length - 2];
            col2 = columns[columns.length - 1];

            // speciel case for the first set of columns as they are holding 7 teasers in total
            if (columns.length === 2) {
                while (col1.length > 1 && col2.length < col1.length - 1 || col1.length === 2 && col2.length === 1) {
                    col2.unshift(col1.pop());
                }
                // our job is done so need to go any further
                return columns;
            }

            tmp = col1.splice(0, col1.length).concat(col2.splice(0, col2.length));

            tmp.forEach(function (teaser, index) {
                if (Math.floor(index / 2) % 2 === 0) {
                    col1.push(teaser);
                } else {
                    col2.push(teaser);
                }
            });

            return columns;
        }

        return {
            getLayout: getLayout,
            getTakeCount: getTakeCount,
            testForNewColumn: testForNewColumn,
            adjustColumns: adjustColumns
        };
    }

    function VideoTeaserGridLayouter() {

    	var _projectsGridLayouter = ProjectsGridLayouter();

    	function getLayout(index) {
    		return _projectsGridLayouter.getLayout(index);
    	}

    	function getTakeCount(alreadyTaken) {
    		return _projectsGridLayouter.getTakeCount(alreadyTaken);
    	}

    	function testForNewColumn(index) {
    		return _projectsGridLayouter.testForNewColumn(index);
    	}

    	function adjustColumns(columns) {
    		var columns = _projectsGridLayouter.adjustColumns(columns);
    		// do some stuff to make sure that the first spot gets a different layout
    		if (columns[0] && columns[0].length === 3) {
    			columns[0][0].layout = 'video';
    		}
    		return columns;
    	}

    	return {
    		getLayout: getLayout,
    		getTakeCount: getTakeCount,
    		testForNewColumn: testForNewColumn,
    		adjustColumns: adjustColumns
    	};
    }


    function SimpleGridLayouter() {
        function getLayout(index) {
            return NARROW;
        }

        function getTakeCount(alreadyTaken) {
            return 1000000;
        }

        function testForNewColumn(index) {
            return index % 3 === 0;
        }

        function adjustColumns(columns) { }	// no adjustments necessary for the simplegrid layout

        return {
            getLayout: getLayout,
            getTakeCount: getTakeCount,
            testForNewColumn: testForNewColumn,
            adjustColumns: adjustColumns
        };
    }

    function NoopHarvester() {
        return {
            harvest: function () { }
        };
    }

    function SimpleGridHarvester() {
        var
			_brandTheme, _theme;

        function harvest(domElm, data) {
            var
				body, parent, themeStr = '';

            if (!_theme) {
                var
					parent = utils.querySelectorParent(domElm, '[data-theme]');
                if (parent) {
                    _theme = parent.dataset.theme;
                }
            }

            data.theme = _theme;
        }

        return {
            harvest: harvest
        };
    }

    function TeaserGridFilterer(allTeasers, showAllFilterOption, layouter, domElm, filterDefinitions) {
    	var
            _allTeasers = allTeasers,
            _filters = [],
            _filter,
            _selectedFilter,
            _allChecked = false,
            _teasers = [],
            _filteredTeasers = [],
            _allChecked = true,
            _showAllFilterOption = showAllFilterOption,
            _showAllText = domElm.dataset.showAllText,
			_preselectFirstFilter = domElm.dataset.preselectFirstFilter,
            _layouter = layouter,
			_filterFromCookie = '';

        function initFilters() {

            var tmpArr = _allTeasers.slice();

            tmpArr.sort(function (a, b) {
                if (a.category < b.category) {
                    return -1;
                }
                return 1;
            });
            _filters = tmpArr.reduce(function (res, teaser) {
                var
                    currentFilter = undefined;

                if (res.length > 0) {
                    currentFilter = res[res.length - 1];
                }
                if (currentFilter && currentFilter.category === teaser.category) {
                    // if we already have a filter and it is the same categorya as the current teaser we just increase the count for that filter.
                    currentFilter.count++;
                    return res;
                }

                // otherwise we create a new filter and add it to the filters array
                currentFilter = {
                    text: teaser.category,
                    category: teaser.category,
                    count: 1
                };

                if (filterDefinitions && filterDefinitions[teaser.category]) {
                    currentFilter.index = filterDefinitions[teaser.category].index;
                    currentFilter.introduction = filterDefinitions[teaser.category].introduction;
                }

                res.push(currentFilter);
                return res;
            }, []);
            _filters.sort(function (f1, f2) {
                if (f1.text > f2.text) {
                    return 1;
                }
                return -1;
            });

            var filterIsSelected = false;
            _filterFromCookie = utils.cookie.get('filter');
            utils.cookie.rem('filter');

            _filters.forEach(function (filter, index) {
                filter.index = index + 1;
                filter.checked = filter.category === _filter || filter.category === _filterFromCookie;
                filterIsSelected = filterIsSelected || filter.checked;
            });

            if (!filterIsSelected && !_showAllFilterOption && _preselectFirstFilter) {
                _filters[0].checked = true;
                _filter = _filters[0].category;
                utils.cookie.set('filter', '', true, true);
            }

            if (_showAllFilterOption) {
                _filters.unshift({
                    text: _showAllText,
                    category: '',
                    index: 0,
                    checked: !filterIsSelected
                });
            }
        }

        function filter(f) {
            //f = f || _filter;
            if (f || _filterFromCookie) {
                _allChecked = false;
                _filter = f || _filterFromCookie;
                _teasers = _allTeasers.reduce(function (result, teaser, index) {
                    if (_.includes(_filter, teaser.category)) {
                        result.push(teaser);
                    }
                    return result;
                }, []);
            } else {
                _allChecked = true;
                _teasers = _allTeasers.slice();
                _filter = "";
            }
            _filters.forEach(function (filter, index) {
                filter.checked = _.includes(_filter, filter.category);
                if (filter.checked) {
                	_selectedFilter = filter;
                	utils.cookie.set('filter', filter.category, true, true);
                }
            });
            _filterFromCookie = '';
        }

        function reset() {
            _teasers = _allTeasers.slice();
            _filteredTeasers = [];
        }

        function take() {
            var
                tmpArr,
                filteredTeasersLength;

            _filteredTeasers.forEach(function (t) {
                t.justAdded = false;
            });
            filteredTeasersLength = _filteredTeasers.length;
            tmpArr = _teasers.splice(0, _layouter.getTakeCount(filteredTeasersLength));
            tmpArr.forEach(function (t, index) {
                t.justAdded = true;
                t.index = filteredTeasersLength + index;
                t.fontSize = undefined;
            });

            _filteredTeasers = _filteredTeasers.concat(tmpArr);
        }

        return {
            getFilters: function () { return _filters; },
            getSelectedFilter: function () { return _selectedFilter; },
            initFilters: initFilters,
            filter: filter,
            reset: reset,
            take: take,
            getTeasers: function () { return _teasers; },
            getFilteredTeasers: function () { return _filteredTeasers },
            allChecked: _allChecked
        }

    }

    function ExpertsFilterer(allTeasers, showAllFilterOption, layouter, domElm, filterDefinitions) {
    	var
            _allTeasers = allTeasers,
            _filters = [],
            _filter,
            _selectedFilters = {
            	competencyFilters: []
            },
            _allChecked = false,
            _teasers = [],
            _filteredTeasers = [],
            _showAllFilterOption = showAllFilterOption,
            _layouter = layouter,
            _showFiltersText = domElm.dataset.showFiltersText,
            _expertsFilterText = domElm.dataset.expertsFilterText,
			_showAllText = domElm.dataset.showAllText,
            _filterFromCookie = '';


    	function initFilters() {
    		var tmpArr = _allTeasers.slice();

    		var competencyFilters = {};

    		tmpArr.forEach(function (teaser) {
    			teaser.competencies.forEach(function (competencyStr, i) {
    				var
                        competency = {};
    				if (!competencyFilters.hasOwnProperty(competencyStr)) {
    					competency.count = 0;
    					competency.checked = false;
    					competency.text = competencyStr;
    					competency.value = competencyStr;
    					competencyFilters[competencyStr] = competency;
    				}
    				competencyFilters[competencyStr].count++;
    			});
    		});

    		function obj2arr(obj) {
    			var arr = [];
    			var property;
    			for (property in obj) {
    				if (obj.hasOwnProperty(property)) {
    					arr.push(obj[property]);
    				}
    			}
    			return arr;
    		}

    		_filters = {
    			competencyFilters: obj2arr(competencyFilters),
    			showFiltersText: _showFiltersText,
    			competenciesText: _expertsFilterText,
				showAllText: _showAllText
    		};

    		var filterIsSelected = false;
    		_filterFromCookie = utils.cookie.get('filter');
    		utils.cookie.rem('filter');

    		_filters.competencyFilters.forEach(function (filter, index) {
    			filter.index = index + 1;
    			filter.checked = filter.category === _filter || filter.category === _filterFromCookie;
    			filterIsSelected = filterIsSelected || filter.checked;
    		});

    		if (_showAllFilterOption) {
    			_filters.competencyFilters.unshift({
    				text: _showAllText,
					value: '',
    				category: '',
    				index: 0,
    				checked: !filterIsSelected
    			});
    		}
		}

    	function filter(f, isClick) {
    		if (isClick) {
    			_filterFromCookie = '';
    			utils.cookie.set('filter', '', true, true);
    		}
    		var appliedCompetencyFilters = utils.getSelectedOptionValues('filter-competencies') || [];
    		if (appliedCompetencyFilters.length === 0 && _filterFromCookie) {
    			if (_filterFromCookie) {
    				appliedCompetencyFilters.push(_filterFromCookie);
    			} else {
    				utils.cookie.rem('filter');
    			}
    		}

    		if (appliedCompetencyFilters.length > 0) {
    			_allChecked = false;

    			_teasers = _allTeasers.reduce(function (result, teaser, index) {
    				var
                        competencyMatch = false;

    				competencyMatch = _.intersection(appliedCompetencyFilters, teaser.competencies).length >= appliedCompetencyFilters.length;

    				if (competencyMatch) {
    					result.push(teaser);
    				}
    				return result;
    			}, []);
    		} else {
    			_allChecked = true;
    			_teasers = _allTeasers.slice();
    		}

    		_filters.competencyFilters.forEach(function (filter, index) {
    			filter.checked = _.includes(appliedCompetencyFilters, filter.value);
    			if (filter.checked) {
    				utils.cookie.set('filter', appliedCompetencyFilters.pop(), true, true);
    			}
    		});
    		if (_allChecked) {
    			_filters.competencyFilters[0].checked = true;
    		}
    		_filterFromCookie = '';
    	}

    	function reset() {
    		_teasers = _allTeasers.slice();
    		_filteredTeasers = [];
    	}

    	function take() {
    		var
                tmpArr,
                filteredTeasersLength;

    		_filteredTeasers.forEach(function (t) {
    			t.justAdded = false;
    		});
    		filteredTeasersLength = _filteredTeasers.length;
    		tmpArr = _teasers.splice(0, _layouter.getTakeCount(filteredTeasersLength));
    		tmpArr.forEach(function (t, index) {
    			t.justAdded = true;
    			t.index = filteredTeasersLength + index;
    			t.fontSize = undefined;
    		});

    		_filteredTeasers = _filteredTeasers.concat(tmpArr);
    	}

    	return {
    		getFilters: function () { return _filters; },
    		getSelectedFilter: function () { return undefined; },
    		initFilters: initFilters,
    		filter: filter,
    		reset: reset,
    		take: take,
    		getTeasers: function () { return _teasers; },
    		getFilteredTeasers: function () { return _filteredTeasers },
    		allChecked: _allChecked
    	}
    }

    function ProjectsGridFilterer(allTeasers, showAllFilterOption, layouter, domElm) {
        var
            _allTeasers = allTeasers,
            _filters = [],
            _filter,
            _selectedFilters = {
                coreServiceFilters: [],
                expertiseAreaFilters: [],
                regionFilters: []
            },
            _allChecked = false,
            _teasers = [],
            _filteredTeasers = [],
            _showAllFilterOption = showAllFilterOption,
            _layouter = layouter,
            _coreServicesText = domElm.dataset.coreServicesText,
            _expertiseAreasText = domElm.dataset.expertiseAreasText,
            _regionsText = domElm.dataset.regionsText,
            _showFiltersText = domElm.dataset.showFiltersText,
            _filtersFromCookie;

        function initFilters() {
            var tmpArr = _allTeasers.slice();

            var coreServiceFilters = {};
            var expertiseAreaFilters = {};
            var regionFilters = {};

            tmpArr.forEach(function (teaser) {
                teaser.coreServices.forEach(function (coreServiceStr, i) {
                    var
                        coreService = {};
                    if (!coreServiceFilters.hasOwnProperty(coreServiceStr)) {
                        coreService.count = 0;
                        coreService.checked = false;
                        coreService.text = coreServiceStr;
                        coreServiceFilters[coreServiceStr] = coreService;
                    }
                    coreServiceFilters[coreServiceStr].count++;
                });
                teaser.expertiseAreas.forEach(function (expertiseAreaStr, i) {
                    var
                        expertiseArea = {};
                    if (!expertiseAreaFilters.hasOwnProperty(expertiseAreaStr)) {
                        expertiseArea.count = 0;
                        expertiseArea.checked = false;
                        expertiseArea.text = expertiseAreaStr;
                        expertiseAreaFilters[expertiseAreaStr] = expertiseArea;
                    }
                    expertiseAreaFilters[expertiseAreaStr].count++;
                });
                teaser.regions.forEach(function (regionStr, i) {
                    var
                        region = {};
                    if (!regionFilters.hasOwnProperty(regionStr)) {
                        region.count = 0;
                        region.checked = false;
                        region.text = regionStr;
                        regionFilters[regionStr] = region;
                    }
                    regionFilters[regionStr].count++;
                });
            });

            function obj2arr(obj) {
                var arr = [];
                var property;
                for (property in obj) {
                    if (obj.hasOwnProperty(property)) {
                        arr.push(obj[property]);
                    }
                }
                return arr;
            }

            _filters = {
                coreServiceFilters: obj2arr(coreServiceFilters),
                expertiseAreaFilters: obj2arr(expertiseAreaFilters),
                regionFilters: obj2arr(regionFilters),
                coreServicesText: _coreServicesText,
                expertiseAreasText: _expertiseAreasText,
                regionsText: _regionsText,
                showFiltersText: _showFiltersText,
                renderFiltersExpanded: _renderFiltersExpanded
            };

        	try {
        		var cookieStr = utils.cookie.get('multifilter');
        		if (cookieStr) {
        			_filtersFromCookie = JSON.parse(cookieStr);
        		} else {
        			_filtersFromCookie = undefined;
        		}
        		if (!_filtersFromCookie.coreServiceFilters || !_filtersFromCookie.expertiseAreaFilters || !_filtersFromCookie.regionFilters) {
        			_filtersFromCookie = undefined;
        		}
        		
        	} catch (ex) {
        		_filtersFromCookie = undefined;
				console.log('Failed to load multi filters from cookie.')
        	}
        	if (!_filtersFromCookie) {
        		_filtersFromCookie = {
        			coreServiceFilters: [],
        			expertiseAreaFilters: [],
        			regionFilters: []
        		};
        	}

            utils.cookie.rem('multifilter');
            _filters.coreServiceFilters.forEach(function (f, i) {
            	f.index = i;
            	f.checked = _.includes(_filtersFromCookie, f.text);
            });
            _filters.expertiseAreaFilters.forEach(function (f, i) {
                f.index = i;
                f.checked = _.includes(_filtersFromCookie, f.text);
            });
            _filters.regionFilters.forEach(function (f, i) {
                f.index = i;
                f.checked = _.includes(_filtersFromCookie, f.text);
            });
        }

        function filter(f, isClick) {
        	var coreServiceFilters = utils.getOptionValues('filter-core-services');
        	var expertiseAreaFilters = utils.getOptionValues('filter-expertise-areas');
        	var regionFilters = utils.getOptionValues('filter-regions');

            var appliedCoreServiceFilters = utils.getSelectedOptionValues('filter-core-services') || [];
            var appliedExpertiseAreaFilters = utils.getSelectedOptionValues('filter-expertise-areas') || [];
            var appliedRegionFilters = utils.getSelectedOptionValues('filter-regions') || [];

            if (isClick) {
            	_filtersFromCookie = {
            		coreServiceFilters: [],
            		expertiseAreaFilters: [],
					regionFilters: []
            	};
            	utils.cookie.set('multifilter', JSON.stringify(_filtersFromCookie), true, true);
            }


            if (appliedCoreServiceFilters.length > 0 || appliedExpertiseAreaFilters.length > 0 || appliedRegionFilters.length > 0 || _filtersFromCookie.coreServiceFilters.length > 0 || _filtersFromCookie.expertiseAreaFilters.length > 0 || _filtersFromCookie.regionFilters.length > 0) {

                _allChecked = false;

                _teasers = _allTeasers.reduce(function (result, teaser, index) {
                    var
                        coreServiceMatch = false,
                        expertiseAreaMatch = false,
                        regionMatch = false;

                    coreServiceMatch = appliedCoreServiceFilters.length === 0 && appliedExpertiseAreaFilters.length === 0 && _filtersFromCookie.coreServiceFilters.length === 0 && _filtersFromCookie.expertiseAreaFilters.length === 0 || _.intersection(appliedCoreServiceFilters, teaser.coreServices).length > 0 || _.intersection(_filtersFromCookie.coreServiceFilters, teaser.coreServices).length > 0;
                    expertiseAreaMatch = appliedExpertiseAreaFilters.length === 0 && appliedCoreServiceFilters.length === 0 && _filtersFromCookie.expertiseAreaFilters.length === 0 && _filtersFromCookie.coreServiceFilters.length === 0 || _.intersection(appliedExpertiseAreaFilters, teaser.expertiseAreas).length > 0 || _.intersection(_filtersFromCookie.expertiseAreaFilters, teaser.expertiseAreas).length > 0;
                    regionMatch = appliedRegionFilters.length === 0 && _filtersFromCookie.regionFilters.length === 0 || _.intersection(appliedRegionFilters, teaser.regions).length > 0 || _.intersection(_filtersFromCookie.regionFilters, teaser.regions).length > 0;

                    if ((coreServiceMatch || expertiseAreaMatch) && regionMatch) {
                        result.push(teaser);
                    }
                    return result;
                }, []);
            	// persist the filters
                if (appliedCoreServiceFilters.length > 0 || appliedExpertiseAreaFilters.length > 0 || appliedRegionFilters.length > 0) {
                	_filtersFromCookie.coreServiceFilters = appliedCoreServiceFilters;
                	_filtersFromCookie.expertiseAreaFilters = appliedExpertiseAreaFilters;
                	_filtersFromCookie.regionFilters = appliedRegionFilters;
                }
                utils.cookie.set('multifilter', JSON.stringify(_filtersFromCookie), true, true);
			} else {
                _allChecked = true;
                _teasers = _allTeasers.slice();
            }

            _filters.coreServiceFilters.forEach(function (filter, index) {
                filter.checked = _.includes(appliedCoreServiceFilters, filter.text) || _.includes(_filtersFromCookie.coreServiceFilters, filter.text);
            });
            _filters.expertiseAreaFilters.forEach(function (filter, index) {
                filter.checked = _.includes(appliedExpertiseAreaFilters, filter.text) || _.includes(_filtersFromCookie.expertiseAreaFilters, filter.text);
            });
            _filters.regionFilters.forEach(function (filter, index) {
                filter.checked = _.includes(appliedRegionFilters, filter.text) || _.includes(_filtersFromCookie.regionFilters, filter.text);
            });


        }

        function reset() {
            _teasers = _allTeasers.slice();
            _filteredTeasers = [];
        }

        function take() {
            var
                tmpArr,
                filteredTeasersLength;

            _filteredTeasers.forEach(function (t) {
                t.justAdded = false;
            });
            filteredTeasersLength = _filteredTeasers.length;
            tmpArr = _teasers.splice(0, _layouter.getTakeCount(filteredTeasersLength));
            tmpArr.forEach(function (t, index) {
                t.justAdded = true;
                t.index = filteredTeasersLength + index;
                t.fontSize = undefined;
            });

            _filteredTeasers = _filteredTeasers.concat(tmpArr);
        }

        return {
            getFilters: function () { return _filters; },
            getSelectedFilter: function () { return undefined; },
            initFilters: initFilters,
            filter: filter,
            reset: reset,
            take: take,
            getTeasers: function () { return _teasers; },
            getFilteredTeasers: function () { return _filteredTeasers },
            allChecked: _allChecked
        }
    }


    window.js = window.js || {};
    js.teaser = (function () {
        var _layouter;
        var _filterer;
        var _harvester;
        var _domElm, _showMore;
        var _template, _filterTemplate;
        var _showFilters = false;
        var _brandTheme = "nne";
        var _showAllText;
    	var _data;


        function more() {
            _filterer.take();
            render();
        }

        function fadeIn() {
            var
                element = document.querySelector(".teaser-deck__spot--hidden"),
                teaser,
                overlay,
                overlayAvailableHeight,
                overlayContent,
                overlayComputedStyles,
                spotHeight,
                overlayHeight,
                headline,
                headlineHeight,
                fontSize = 1.0;

            if (element) {
                teaser = _filterer.getFilteredTeasers()[parseInt(element.dataset.filteredTeaserIndex, 10)];
                spotHeight = element.clientHeight;
                overlay = element.querySelector(".teaser-deck__overlay");
                overlayComputedStyles = getComputedStyle(overlay);

                headline = element.querySelector('.teaser-deck__headline');
                headlineHeight = headline.getBoundingClientRect().height;

                overlayAvailableHeight = overlay.getBoundingClientRect().height - headline.offsetTop - (parseFloat(overlayComputedStyles.paddingBottom) / 2);

                if (headlineHeight > overlayAvailableHeight) {
                	fontSize = parseFloat(getComputedStyle(headline).fontSize);
                	var i = 50; // just a safe guard against infinite loops
                	while (headlineHeight > overlayAvailableHeight && i > 0) {
                		i--;
                		fontSize *= 0.95;
                		headline.style.fontSize = fontSize + 'px';
                		headlineHeight = headline.getBoundingClientRect().height;
                	}

                    teaser.fontSize = fontSize + "px";
                }

                element.classList.remove("teaser-deck__spot--hidden");
                setTimeout(fadeIn, 80);
            }
        }

        function render(filter) {
            var
                viewModel = {
                    columns: [],
                    filters: _filterer.getFilters(),
                    showFilters: _showFilters,
                    showMore: _showMore,
                    showMoreText: _domElm.dataset.showMoreText,
                    allChecked: _filterer.allChecked,
                    brandTheme: _brandTheme,
                    selectedFilter: _filterer.getSelectedFilter()
                },
                renderer,
                tmpColumn,
                tmpTeaser;

            if (_filterer.getTeasers().length === 0) {
                viewModel.showMore = false;
            }
            viewModel.renderFiltersExpanded = _renderFiltersExpanded;


            // first assign a layout to each teaser based on its index into the layoutMap array.
            _filterer.getFilteredTeasers().forEach(function (teaser, i) {
                teaser.layout = _layouter.getLayout(i);
                var headlineParts = teaser.headline.split("##");
                teaser.headlinePre = headlineParts.shift();
                teaser.headlineHighlight = headlineParts.shift();
                teaser.headlinePost = headlineParts.join(' ');
                teaser.coreService = teaser.coreServices && teaser.coreServices[0] ? teaser.coreServices[0] : '';
                teaser.subHeadline = teaser.subtitle;
                teaser.theme = teaser.originalTheme;
            });

            // now put the teasers into column arrays
            viewModel.columns = _filterer.getFilteredTeasers().reduce(function (res, teaser, index) {
                var
                    a;
                if (_layouter.testForNewColumn(index)) {
                    res.push([]);
                }
                a = res[res.length - 1];
                a.push(teaser);

                return res;
            }, []);

            _layouter.adjustColumns(viewModel.columns);

            viewModel.columns.forEach(function (column) {
            	column.forEach(function (teaser) {
            		// Now select the image preset
            		if (teaser.layout === LARGE) {
            			teaser.preset = teaser.transparency === 'transparent' ? 'magazine-teaser' : 'magazine-teaser-wide';
            		} else if (teaser.layout === MEDIUM) {
            			teaser.preset = teaser.transparency === 'transparent' ? 'magazine-teaser-medium-wide' : 'magazine-teaser-medium-narrow';
            		} else if (teaser.layout === NARROW) {
            			teaser.preset = teaser.transparency === 'transparent' ? 'magazine-teaser-narrow' : 'magazine-teaser-narrow-small';
            		}
            		if (teaser.transparency === 'opaque') {
            			// no need to look for further adjustments
            			return;
            		}

            		var removeTransparency = false;
            		if (teaser.layout === LARGE && teaser.focalpointY && teaser.focalpointY > 45) {
            			teaser.preset = 'magazine-teaser-wide';
            			removeTransparency = true;
            		} else if (teaser.layout === MEDIUM && teaser.focalpointX && teaser.focalpointX < 60) {
            			teaser.preset = 'magazine-teaser-medium-narrow';
            			removeTransparency = true;
            		} else if (teaser.layout === NARROW && teaser.focalpointY && teaser.focalpointY > 45) {
            			teaser.preset = 'magazine-teaser-narrow-small';
            			removeTransparency = true;
            		}

            		if (removeTransparency) {
            			teaser.theme = teaser.theme.replace('trans-', '');
            		}

            	});
            });

        	
            renderer = Hogan.compile(_template);

            var filtersPartial = Hogan.compile(_filterTemplate);
            var html = renderer.render(viewModel, { filters: filtersPartial });
            _domElm.innerHTML = html;

            setTimeout(fadeIn, 200);
        }

        function harvestInlineData(domElm) {
            var fragment = document.createDocumentFragment();
            var html = domElm.querySelector('.js-magazine-deck__data-container');
            if (!html) {
                return false;
            }

            var htmlContent = html.textContent;
            var div = document.createElement('div');

            div.innerHTML = htmlContent;
            fragment.appendChild(div);
            //console.log(htmlContent);
            var spotsJson = {
                teasers: [],
                filterDefinitions: {}
            };

            var filterDefinitions = Array.prototype.slice.call(fragment.querySelectorAll('.js-filter-data'));
            filterDefinitions.forEach(function (filterData, i) {
                var
					filterKey = filterData.dataset.category,
					filterDetails = {
					    introduction: filterData.dataset.introduction,
					    index: i
					};
                spotsJson.filterDefinitions[filterKey] = filterDetails;
            });

            var spotElements = Array.prototype.slice.call(fragment.querySelectorAll('.js-magazine-deck__teaser-data'));

            spotElements.forEach(function (spotData) {
                //console.log('spotData.dataset', spotData.dataset);
                var transparencyAddOn = '';
                var categoryParent;

                if (spotData.dataset.transparency != 'opaque') {
                    transparencyAddOn = 'trans-';
                }
                var spotJson = {
                    category: spotData.dataset.category,
                    headline: spotData.dataset.title,
                    teaser: spotData.dataset.bodyText,
                    image: spotData.dataset.imageUrl,
                    theme: transparencyAddOn + spotData.dataset.theme,
                    originalTheme: transparencyAddOn + spotData.dataset.theme,
                    href: spotData.dataset.href,
                    subtitle: spotData.dataset.subtitle,
                    video: spotData.dataset.video,
                    embedcode: spotData.dataset.embedcode,
                    focalpointX: spotData.dataset.focalpointX,
                    focalpointY: spotData.dataset.focalpointY,
					transparency: spotData.dataset.transparency
                };

                if (!spotJson.category) {
                	categoryParent = utils.querySelectorParent(spotData, "[data-category]");
                    if (categoryParent) {
                        spotJson.category = categoryParent.dataset.category;
                    }
                }
                //console.log('dataset:', spotData.dataset);
                try {
                    spotJson.coreServices = JSON.parse(spotData.dataset.coreServices);
                } catch (err) {
                    spotJson.coreServices = [];
                }
                try {
                    spotJson.expertiseAreas = JSON.parse(spotData.dataset.expertiseAreas);
                } catch (err) {
                    spotJson.expertiseAreas = [];
                }
                try {
                    spotJson.regions = JSON.parse(spotData.dataset.regions);
                } catch (err) {
                    spotJson.regions = [];
                }
            	try {
            		spotJson.competencies = JSON.parse(spotData.dataset.competencies);
            	} catch (err) {
            		spotJson.competencies = [];
            	}

                _harvester.harvest(spotData, spotJson);

                spotsJson.teasers.push(spotJson);
            });
            return spotsJson;
        }

        function initialize(domElm, templateUrl, filterTemplateUrl, jsonUrl, showMore, showFilters, showAllFilterOption, brandTheme, showAllText, layoutAlgorithm) {
            var
                selectedFilters, filtererFactory, showFilters;

            _data = arguments[arguments.length - 1];

            _showMore = showMore.toLowerCase() === 'true';
            _showFilters = showFilters.toLowerCase() === 'true';
            var showAllFilterOption = showAllFilterOption ? showAllFilterOption.toLowerCase() === 'true' : false;
            _domElm = domElm;
            _brandTheme = brandTheme ? brandTheme : _brandTheme;
            _showAllText = showAllText;
            if (layoutAlgorithm == 'projects') {
                _layouter = ProjectsGridLayouter();
                _harvester = NoopHarvester();
                filtererFactory = ProjectsGridFilterer;
            } else if (layoutAlgorithm === 'simple') {
            	_layouter = SimpleGridLayouter();
            	_harvester = SimpleGridHarvester();
            	filtererFactory = TeaserGridFilterer;
            } else if (layoutAlgorithm === 'experts') {
            	_layouter = SimpleGridLayouter();
            	_harvester = SimpleGridHarvester();
            	filtererFactory = ExpertsFilterer;
            } else if (layoutAlgorithm === 'video') {
            	_layouter = VideoTeaserGridLayouter();
            	_harvester = NoopHarvester();
            	filtererFactory = TeaserGridFilterer;
            } else {
                _layouter = TeaserGridLayouter();
                _harvester = NoopHarvester();
                filtererFactory = TeaserGridFilterer;
            }

            if (!templateUrl || !jsonUrl) {
                return;
            }

            _domElm.addEventListener('click', function (e) {
                if (e.target.classList.contains('js-teaser-deck__show-more-button')) {
                    e.preventDefault();
                    more();
                    return;
                }
                if (e.target.classList.contains('js-filters__option')) {
                    _filterer.reset();
                    selectedFilters = utils.getSelectedOptionValues('filter-teasers');
                    _filterer.filter(selectedFilters, true);
                    _filterer.take();
                    render();
                }
                if (e.target.classList.contains('js-filters__drowpdown-activator')) {
                    e.preventDefault();
                    var elm = document.querySelector(".js-filters__list");
                    if (elm.classList.contains("active")) {
                        _renderFiltersExpanded = false;
                        elm.classList.remove("active");
                        elm.setAttribute('style', '');
                        e.target.parentElement.classList.remove('filters--active');
                    } else {
                        elm.classList.add("active");
                        _renderFiltersExpanded = true;
                        elm.setAttribute('style', 'height:' + (elm.clientHeight + 1) + 'px');
                        e.target.parentElement.classList.add('filters--active');
                    }
                }
            }, false);

            var jsonPromise;
            if (jsonUrl === "INLINE") {
                jsonPromise = new Promise(function (resolve, reject) {
                	var data = harvestInlineData(domElm);
                    if (data) {
                        resolve(
                            {
                                json: function () {
                                    return new Promise(function (resolve, reject) {
                                        resolve(data);
                                    })
                                }
                            }
                        );
                    } else {
                        reject(Error("Unable to harvest data"));
                    }
                });
            } else {
                jsonPromise = fetch(jsonUrl);
            }
            var templatePromise = fetch(templateUrl);
            var filterTemplatePromise = fetch(filterTemplateUrl);

            Promise.all([jsonPromise, templatePromise, filterTemplatePromise]).then(function (results) {
                Promise.all([
                    results[0].json(),
                    results[1].text(),
                    results[2].text()
                ]).then(function (results) {
                    _filterer = filtererFactory(results[0].teasers, showAllFilterOption, _layouter, _domElm, results[0].filterDefinitions);
                    //_allTeasers = results[0].teasers;
                    // also make a clone of the _allTeasers array that will be used for grabbing the items to render from
                    _template = results[1];
                    _filterTemplate = results[2];

                    _filterer.reset();
                    _filterer.initFilters();
                    _filterer.filter();
                    _filterer.take();
                    render();
                });
            });
        }



        return {
            initialize: initialize
        };
    })();
})();